import { createContext } from 'react';

import type { ViewedOrganization } from '@/api/viewing-scope';

export interface ViewingContextValue {
  /** The organization being viewed read-only, or null. */
  viewing: ViewedOrganization | null;
  /** Start viewing an organization. Does nothing for anybody but staff. */
  enter: (organization: ViewedOrganization) => void;
  /** Stop viewing. */
  exit: () => void;
  /**
   * True between choosing Exit and arriving on a staff page. The view stays on
   * until then, so the organization page still on screen is never refused on
   * the way out.
   */
  leaving: boolean;
  /** Ask to stop viewing once a staff page is showing. */
  leave: () => void;
}

/**
 * In its own file, separate from the provider component: a file exporting both
 * a component and a non-component value breaks Vite's hot reloading.
 */
export const ViewingContext = createContext<ViewingContextValue | null>(null);
